import { Alert, Divider, notification, Radio, Space, Table, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useExpertProfilesContext } from '../../../../context/expertProfile'
import { getExpertsPayouts } from '../../../../context/experts/utils'

import { columns } from './columns'
import { useAccountContext } from '../../../../context/account'
import { useParams } from 'react-router-dom'
import ExpertRateForm from './ExpertRateForm/ExpertRateForm'
import { Channel, PaymentType } from '../../../../context/types'
import SendDotsPayout from '../../../helpers/SendDots/SendDotsPayout'
import FillDataAlert from '../FillDataAlert'

const { Text, Title, Paragraph } = Typography

enum PayoutOptions {
	Charity,
	Stripe,
}

type UrlParam = {
	accountId: string
}

const Payouts = () => {
	const { expertProfiles, actions } = useExpertProfilesContext()

	const [payouts, setPayouts] = useState<any[]>([])

	const [payoutOption, setPayoutOption] = useState(0)
	const { account } = useAccountContext()
	const { accountId } = useParams() as UrlParam

	useEffect(() => {
		if ((!!account?.token && !!accountId) || !accountId) {
			const token = account?.token && !!accountId ? account.token : null
			actions.setError()
			actions.getExpertProfiles(token)
			getExpertsPayouts(token)
				.then((r) => {
					setPayouts(r.calls)
				})
				.catch(handleError)
		}
	}, [account?.token])

	useEffect(() => {
		setPayoutOption(expertProfiles.profiles[0]?.payment_type === PaymentType.CHARITY ? 0 : 1)
	}, [expertProfiles])

	const handlePayoutOption = (option: number) => {
		if (option === payoutOption || !expertProfiles.profiles[0]?.id) return

		setPayoutOption(option)

		actions
			.updateExpertProfile(
				expertProfiles.profiles[0].id,
				{
					payments_to_charity: option === PayoutOptions.Charity,
				},
				account?.token
			)
			.catch(handleError)
	}

	const handleError = (err: any) => {
		notification.error({ message: err.message || 'Error' })
	}

	if (!expertProfiles.profiles[0]) return <></>

	const channelInfoList: Channel[] = expertProfiles.profiles[0].channels?.filter((v) => v.payout_info)

	return (
		<Space direction="vertical" size="large" style={{ display: 'block' }}>
			<FillDataAlert />
			<Title level={3}>How would you like to handle payments?</Title>
			{!!(channelInfoList && channelInfoList.length) && (
				<ul>
					{channelInfoList.map((channel) => (
						<li key={channel.id}>
							When someone books a call with you through <b>{channel.name}</b>, the payout structure is:{' '}
							<b>{channel.payout_info}</b>
						</li>
					))}
				</ul>
			)}
			{!!expertProfiles.profiles[0]?.brand?.experts_can_set_rates && (
				<ExpertRateForm expertProfile={expertProfiles.profiles[0]} />
			)}
			<Radio.Group
				onChange={(e) => handlePayoutOption(e.target.value)}
				value={payoutOption}
				disabled={!!account?.token}
			>
				<Space direction="vertical">
					<Radio value={0}>
						<Space direction="vertical">
							<Title level={5} className="expert-profile-form-wrap">
								I would like you to donate my fees to charity
							</Title>
							<Paragraph className="expert-profile-form-wrap">
								Your charity donation will go to the getWise foundation to support women and underserved founders and
								professionals with grants to help them thrive.
							</Paragraph>
						</Space>
					</Radio>

					<Radio value={1}>
						<Space direction="vertical">
							<Title level={5} className="expert-profile-form-wrap">
								<Text>I would like to get paid directly. </Text>
							</Title>
							<Alert
								type="info"
								showIcon
								message=""
								description="All payments are issued monthly. Once you complete your first call, you will be contacted by our expert concierge team to connect to our payout provider."
							/>
						</Space>
					</Radio>
				</Space>
			</Radio.Group>

			{expertProfiles.profiles[0].user?.expertInfo?.sendDotsVerificationId &&
				expertProfiles.profiles[0].payment_type === PaymentType.SENDDOTS && (
					<div style={{ textAlign: 'right' }}>
						<SendDotsPayout />
					</div>
				)}

			<Divider />

			<Title level={3}>Payouts</Title>
			<Table
				rowKey={'call_id'}
				columns={columns}
				dataSource={payouts}
				pagination={{ pageSize: 100, current: 1, total: payouts.length }}
				scroll={{ x: true }}
			/>
		</Space>
	)
}

export default Payouts
